import { Injectable } from '@angular/core';
import {Venmaegrupos} from '../veninterfaces/venmaegrupos';
import {HttpClient} from '@angular/common/http';
import {UsuarioEsquema} from '../../usuarioEsquema';
import {Usuario} from '../../usuario';
import {Observable} from 'rxjs';
import { ConfInicialesService } from 'src/app/servicios/conf-iniciales.service';

@Injectable({
  providedIn: 'root'
})
export class VenmaegruposService {
  get venmaegrupo(): Venmaegrupos[] {
    return this._venmaegrupo;
  }

  set venmaegrupo(value: Venmaegrupos[]) {
    this._venmaegrupo = value;
  }
  public url: string;
  public way: string;
  private _venmaegrupo: Venmaegrupos[];

  constructor(private http: HttpClient,
              public usuarioEsquema: UsuarioEsquema,
              public usuario: Usuario,
              private confIniciales: ConfInicialesService) {
    this.url = sessionStorage.getItem('url');
    this.way = sessionStorage.getItem('way');
  }
  getGrupos(): Observable<any[]> {
    return this.http.post<any[]>(this.way + '/ventas/grupos/107761bf671c', {
        elementos: {}
    }, this.confIniciales.httpOptions());
  }
  insertarGrupo(grupo: Venmaegrupos): Observable<any[]> {
    return this.http.post<any>(this.way + '/ventas/grupos/4afc76fb0dfb38', {
      elementos: {
       p_GRU_tipo: grupo.GRU_TIPO,
        p_GRU_codigo: grupo.GRU_CODIGO,
        p_GRU_nombre: grupo.GRU_NOMBRE,
        p_CON_codigo: grupo.CON_CODIGO,
        p_CON_codigodes: grupo.CON_CODIGODES,
        p_GRU_pordes: grupo.GRU_PORDES,
        p_CEN_codigo: grupo.CEN_CODIGO,
      }
    }, this.confIniciales.httpOptions());
  }
  actualizarGrupo(grupo: Venmaegrupos, codigo): Observable<any[]> {
    return this.http.post<any>(this.way + '/ventas/grupos/299df2ab2', {
      elementos: {
        p_GRU_tipo: grupo.GRU_TIPO,
        p_GRU_codigoa: codigo,
        p_GRU_codigo: grupo.GRU_CODIGO,
        p_GRU_nombre: grupo.GRU_NOMBRE,
        p_CON_codigo: grupo.CON_CODIGO,
        p_CON_codigodes: grupo.CON_CODIGODES,
        p_GRU_pordes: grupo.GRU_PORDES,
        p_CEN_codigo: grupo.CEN_CODIGO,
      }
    }, this.confIniciales.httpOptions());
  }
  eliminarGrupo(grupo: Venmaegrupos): Observable<any[]> {
    return this.http.post<any>(this.way + '/ventas/grupos/eacad2bab70df800', {
      elementos: {
        p_GRU_tipo: grupo.GRU_TIPO,
         p_GRU_codigo: grupo.GRU_CODIGO
      }
    }, this.confIniciales.httpOptions());
  }

  erFindCodGrupo(grupo) {    
    return this.http.post(this.way + '/ventas/grupos/edbe576b30d9400000000', {
      elementos: {
        GRU_CODIGO: grupo
      },
    }, this.confIniciales.httpOptions());
  }
  //CDPJ
  encontrarArtCntaySer(strArtCodigo, strtipo) {
    return this.http.post<any[]>(this.way + '/ventas/facturas/75d98bf76adab8000000', {
      elementos: {
        ArtCodigo: strArtCodigo,
        strTIPO: strtipo
      }
    }, this.confIniciales.httpOptions()).toPromise();
  }
  //CDPJ
}
